// src/modules/dashboard/api.js
// What remains of the retired /dashboard module. The role-stats / quick-stats /
// dashboard-data calls that fed the old hardcoded dashboard are gone — dashboards
// are now built per role and rendered from /dashboard-builder/render (see
// modules/moduleDashboards/api.js).
import API from '../../services/api';

export const fetchBranches = async () => {
  try {
    const response = await API.get('/branches');
    return response.data;  // Return the response data
  } catch (error) {
    console.error('Error fetching branches:', error);
    throw error;
  }
};
